import React, { useState } from 'react'
import LightText, { DarkBold, LighterBold, Lightly } from '../../Assets/CSS/Text';
import { Icon } from '@iconify/react/dist/iconify.js';
import { format } from 'date-fns';
import './ViewDept.css'


const ViewDepartment = ({ show, handleClose, employeeData, onEdit, onDelete }) => {

    if (!show || !employeeData) return null;
    const departmentColors = {
        'software development': { background: '#CEE2FF', color: '#003DA6' },
        'quality assurance': { background: '#CEFFD5', color: '#13A600' },
        'project management': { background: '#CEFBFF', color: '#00A69D' },
        'ux ui design': { background: '#F0CEFF', color: '#9200A6' },
        'business analysis': { background: '#FFE5E5', color: '#A60000' }, // example inactive style
    };
    const getDeptColors = (deptName) => {
        if (!deptName) return { background: '#FFFACE', color: '#A69500' }; // default
        const key = deptName.toLowerCase().trim();
        return (
            Object.entries(departmentColors).find(([k]) => key.includes(k))?.[1] || {
                background: '#FFFACE',
                color: '#A69500',
            }
        );
    };
    const { background, color } = getDeptColors(employeeData?.name);
    return (
        <>
            {/* Backdrop */}
            <div className="modal-backdrop fade show"></div>

            {/* Modal */}
            <div
                className="modal show d-block scrollable"
                tabIndex="-1"
                style={{
                    background: "rgba(0,0,0,0.5)",
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    zIndex: 1055,
                    overflowY: "auto",
                }}
            >
                <div
                    className="modal-dialog modal-dialog-centered"
                    style={{
                        maxWidth: "600px", width: "100%",
                        boxShadow: '0px 4px 14px 0px #0000000D'
                    }}
                >
                    <div className="modal-content p-4 rounded-4 shadow-sm"
                        style={{
                            maxHeight: "90vh",  // 👈 modal will not exceed 90% of viewport height
                            overflowY: "auto",  // 👈 scroll inside modal content

                        }}>

                        {/* Header */}
                        <div className="d-flex justify-content-between align-items-center mb-3"
                            style={{ borderBottom: '1px solid #D6D6D6' }}>
                            <div className="d-flex align-items-center gap-1">
                                <span
                                    style={{
                                        width: '56px',
                                        height: '56px',
                                        position: 'relative',
                                        top: '0px',
                                        marginBottom: '10px',
                                        left: '-10px',
                                        borderRadius: '10px',
                                        border: '1px solid #DEDEDE',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '28px',
                                        fontWeight: '500',
                                        background,
                                        color,
                                    }}
                                >
                                    {employeeData?.name
                                        ? employeeData.name
                                            .split(' ')
                                            .slice(0, 2)                 // split into words
                                            .map(word => word[0])     // take first letter of each
                                            .join('')                 // combine
                                            .toUpperCase()            // make uppercase
                                        : 'SD'}
                                </span>
                                <div>
                                    <h5 className="mb-0 fw-semibold">
                                        {employeeData.name || "Department Name"}
                                    </h5>
                                </div>
                            </div>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={handleClose}
                            ></button>
                        </div>

                        {/* Status */}
                        <div className="mb-3">
                            <span className=" px-3 py-2 fs-6"
                                style={{
                                    border: "1px solid #DEDEDE",
                                    borderRadius: "10px",
                                    background:
                                        employeeData.status === "Active" ? "#D9FFD4" : "#FEF2F2",
                                    color:
                                        employeeData.status === "Active" ? "#1EA70C" : "#A70C0C",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px", // space between label and switch
                                }}>
                                <span style={{ fontWeight: '500', color: '#000000' }}>Status :</span>
                                {employeeData.status}</span>
                        </div>


                        {/* Head of Department */}


                        <div className="border rounded-3 mb-3">
                            {/* Header Section */}
                            <div
                                className="d-flex justify-content-between align-items-center px-3 py-2"
                                style={{ background: "#EAFAFF" }}
                            >
                                <h6 className="fw-semibold mb-0">
                                    Head Of Department
                                    <small className="ps-1 text-muted">(Contact)</small>
                                </h6>
                            </div>

                            {/* Body Section */}
                            <div className="p-3">
                                <div className="d-flex align-items-start gap-2">
                                    {/* Left column: image + icons */}
                                    <div className="d-flex flex-column align-items-center gap-3">
                                        {/* <img
                                            src={employeeData.hodImage || "https://via.placeholder.com/50"}
                                            alt="Head"
                                            className="rounded-circle border"
                                            width="30"
                                            height="30"
                                        /> */}
                                        <div
                                            className="rounded-circle d-flex justify-content-center align-items-center"
                                            style={{
                                                width: "30px",
                                                height: "30px",
                                                fontSize: "12px",
                                                color: "#999",
                                                backgroundColor: "#F0F0F0",
                                                border: "1px solid #F0F0F0 ",
                                            }}
                                        >
                                            <Icon icon="proicons:person" className="fs-5 " style={{}} />
                                        </div>
                                        {/* <Icon icon="ic:outline-email" width="18" height="18" />
                                        {/* <Icon icon="material-symbols:call-outline" className='mt-2' width="18" height="18" /> */}
                                    </div>

                                    {/* Right column: name + contact info */}
                                    <div className=' d-flex  flex-column gap-3'>
                                        <p className="mb-1 fw-semibold">
                                            {employeeData.headName || "Anjali Singh"}
                                        </p>

                                        {/* <div className="d-flex align-items-center gap-3 text-muted mb-1">
                                            <span style={{ fontSize: "14px" }}>
                                                {employeeData.headEmail || "anjali@raksoftech.com"}
                                            </span>
                                        </div>

                                        <div className="d-flex align-items-center gap-2 text-muted">
                                            <span style={{ fontSize: "14px" }}>
                                                {employeeData.headPhoneNumber || "+91 12345 67890"}
                                            </span>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>






                        {/* Description */}
                        <div className="border rounded-3  mb-3">
                            <div
                                className="d-flex justify-content-between align-items-center px-3 py-2"
                                style={{ background: "#EAFAFF" }}
                            >
                                <h6 className="fw-semibold mb-0">Description</h6>

                            </div>
                            <p className="text-muted mb-0 px-3 py-2" style={{ fontSize: "14px" }}>
                                {employeeData.description ||
                                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."}
                            </p>
                        </div>

                        {/* Employees */}

                        <div className="border rounded-3  mb-3">
                            <div
                                className="d-flex justify-content-between align-items-center px-3 py-2"
                                style={{ background: "#EAFAFF" }}
                            >
                                <h6 className="fw-semibold mb-0">Employees ({employeeData.employeeNames?.length || 0})</h6>

                            </div>
                            {/* <ul className="list-unstyled mb-0 px-3 py-2">
                                {(employeeData.employeeNames || [
                                    "Radha Kumar",
                                    "Arjali Singh",
                                    "Ashish Kumar",
                                    "Manoj Pande",
                                    "Arvindha Kadam",
                                ]).map((emp, i) => (
                                    <li key={i} className="d-flex align-items-center gap-2 mb-1">
                                    
                                        <div
                                            className="rounded-circle d-flex justify-content-center align-items-center"
                                            style={{
                                                width: "30px",
                                                height: "30px",
                                                fontSize: "12px",
                                                color: "#999",
                                                backgroundColor: "#F0F0F0",
                                                border: "1px solid #F0F0F0 ",
                                            }}
                                        >
                                            <Icon icon="proicons:person" className="fs-4 " style={{}} />
                                        </div>
                                        <span>{emp}</span>
                                    </li>
                                ))}
                            </ul> */}
                            <ul className="list-unstyled mb-0 px-3 py-2">
                                {(employeeData.employeeNames || [
                                    "Radha Kumar",
                                    "Arjali Singh",
                                    "Ashish Kumar",
                                    "Manoj Pande",
                                    "Arvindha Kadam",
                                ]).map((emp, i) => {
                                    // Capitalize first letter of each word
                                    const formattedName = emp
                                        .split(" ")
                                        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                        .join(" ");

                                    return (
                                        <li key={i} className="d-flex align-items-center gap-2 mb-1">
                                            <div
                                                className="rounded-circle d-flex justify-content-center align-items-center"
                                                style={{
                                                    width: "30px",
                                                    height: "30px",
                                                    fontSize: "12px",
                                                    color: "#999",
                                                    backgroundColor: "#F0F0F0",
                                                    border: "1px solid #F0F0F0 ",
                                                }}
                                            >
                                                <Icon icon="proicons:person" className="fs-4" />
                                            </div>
                                            <span>{formattedName}</span>
                                        </li>
                                    );
                                })}
                            </ul>

                        </div>

                        {/* Last Updated */}
                        <div className="border rounded-3  mb-3">
                            <div
                                className="d-flex justify-content-between align-items-center px-3 py-2"
                                style={{ background: "#EAFAFF" }}
                            >
                                <h6 className="fw-semibold mb-0">Last Updated</h6>

                            </div>
                            <div className="d-flex justify-content-between px-3 py-2">
                                <div>
                                    <p className="mb-0 text-muted small">Updated by:</p>
                                    <p className="fw-semibold mb-0">
                                        {employeeData.updatedBy || "Arjali Singh"}
                                    </p>
                                </div>
                                <div>
                                    <p className="mb-0 text-muted small">Updated on:</p>
                                    <p className="fw-semibold mb-0">
                                        {employeeData.updatedOn || "2 Mar 2023"}
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Created By */}

                        <div className="border rounded-3  mb-3">
                            <div
                                className="d-flex justify-content-between align-items-center px-3 py-2"
                                style={{ background: "#EAFAFF" }}
                            >
                                <h6 className="fw-semibold mb-0">Created By</h6>

                            </div>
                            <div className="d-flex justify-content-between px-3 py-2">
                                <div>
                                    <p className="mb-0 text-muted small">Created by:</p>
                                    <p className="fw-semibold mb-0">
                                        {employeeData.createdBy || "Arjali Singh"}
                                    </p>
                                </div>
                                <div>
                                    <p className="mb-0 text-muted small">Created on:</p>
                                    <p className="fw-semibold mb-0">
                                        {/* {employeeData.createdDate || "12 Feb 2023"} */}
                                        {employeeData?.createdDate ? format(new Date(employeeData.createdDate), "dd MMM, yyyy") : "-"}
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Parent Department */}
                        <div className="border rounded-3  mb-3">
                            <div
                                className="d-flex justify-content-between align-items-center px-3 py-2"
                                style={{ background: "#EAFAFF" }}
                            >
                                <h6 className="fw-semibold mb-0">Parent Department</h6>

                            </div>
                            <p className="text-muted mb-0 px-3 py-2">
                                {employeeData.parentDept || "Project Management"}
                            </p>
                        </div>


                        {/* Footer Buttons */}
                        <div className="d-flex justify-content-between align-items-center mt-5">
                            <button className="btn "
                                style={{ border: '1px solid #909090', color: '#909090' }}
                                onClick={handleClose}>
                                Close
                            </button>
                            <div className="d-flex gap-2">
                                <button className="btn create-btn"
                                    // style={{ border: '1px solid #00AFEF', color: '#00AFEF' }}
                                    onClick={() => onEdit(employeeData)}>
                                    <Icon icon='mdi:edit' className='mx-2' />Edit</button>
                                <button className="btn" style={{ color: '#DD0000' }}
                                    onClick={() => onDelete(employeeData)}>
                                    <Icon icon='material-symbols:delete-outline' className='mx-2' />Delete</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewDepartment
